import moment from "moment"

export const insightsDate = (datestring, long = false) =>
  long
    ? moment(new Date(datestring)).format("D MMMM, YYYY")
    : moment(new Date(datestring)).format("MMM D, YYYY")

export const insightsPath = (art) => {
  const cat = art.insightsCategories?.length
    ? art.insightsCategories[0].slug
    : "insights"
  return `/${cat}/${art.slug}/`.toLowerCase()
}

export const getPost = async (path, id, apiKey) => {
  let url = `${process.env.GATSBY_DEMAND360_SIGNUP_API}/insight?`
  if (id) {
    url += `id=${id}&api-key=${apiKey}`
  } else {
    const cleanPath = path.replace(/^\/+|\/+$/g, "")
    url += `path=${cleanPath}`
  }
  try {
    const response = await fetch(url)
    const body = await response.json()
    if (body.insightsArticle) {
      const post = body.insightsArticle
      return post
    }
  } catch (e) {
    return null
  }
  return null
}
